import { PlanningTemplateView } from "@features/rh/horaires-de-travail/components/PlanningTemplateView";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, useParams } from "@tanstack/react-router";

function PlanningTemplateViewWrapper() {
  const { id } = useParams({ from: "/_app/rh/horaires-de-travail/$id/view" });
  return <PlanningTemplateView planningTemplateId={Number(id)} />;
}

export const Route = createFileRoute("/_app/rh/horaires-de-travail/$id/view")({
  loader: requirePermission(PERMISSIONS.RH.PLANNING.VIEW),
  staticData: {
    title: "Détails horaire",
    permission: PERMISSIONS.RH.PLANNING.VIEW,
    module: "rh",
    showInTab: false,
    showInNav: false,
    showInBreadcrumb: true,
  },
  component: PlanningTemplateViewWrapper,
});
